module.exports = __webpack_public_path__ + "static/media/S (144).de8022c2.jpg";